<template lang="pug">
    .component-driver-password-smart-edit


        smart-edit(:options="options", :value="item", @input="updateFields")
        .callout.alert
            h3
                strong Warning
            h5 This may have legal implications
            p Inform the user to update his password as soon as possible
        button.button.expanded(v-on:click="edit") Save and Submit
</template>
<script type="text/babel">
    import SmartEdit from "components/structure/SmartEdit"
    import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
    import MaggieHelper from "src/maggieHelper";

    export default {
        name: "DriverPasswordSmartEdit",
        components: {SmartEdit},
        data() {
            return {
                options: {
                    translations: {},
                    types: {
                        password: 'password'
                    },
                    disabled: [
                        "id",
                        "uid",

                        "name",
                        "surname",
                    ],
                    list: [
                        "id",
                        "uid",
                        "name",
                        "surname",
                        "password"

                    ],
                    listMode: 'whitelist',
                }
            }
        },
        created() {

        },
        methods: {
            updateFields(item) {
                this.item = item
            },
            edit() {
                KeplerBackofficeSdk.drivers.select(this.item.id)
                    .setNewPassword({password: this.item.password}, (data) => {
                        MaggieHelper.notification('Password updated', `Password for ` + this.item.name + ` ` + this.item.surname + ` (DR` + this.item.id + ') was updated successfully. ');
                        this.item = null;
                        MaggieHelper.closeRightPanel()
                    })
            },

        },
        props: [
            'item',
        ]
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// DriverEditPassword.vue?869d2fb0